import { useCallback } from 'react';
import { IconButton2, Tooltip } from '@frameio/vapor';
import { IconPlus } from '@frameio/vapor-icons';
import { useShowCreateWorkspaceModal } from '../../../../settings';
import { useCanCreateWorkspace } from '../../../../shared';
import { useWorkspaceLimit } from '../../../../shared/hooks';
import { usePaginatedWorkspaces } from '../../../../shared/hooks/usePaginatedWorkspaces';
import TEXT from './generated/TEXT/CreateButton';

export const CreateButton = () => {
  const canCreateWorkspace = useCanCreateWorkspace();
  const showCreateWorkspaceModal = useShowCreateWorkspaceModal();
  const { items } = usePaginatedWorkspaces();
  const {
    shouldShowCreateButton,
    isCreateButtonDisabled,
    limitReachedTooltip,
  } = useWorkspaceLimit();
  const shouldShow = shouldShowCreateButton(canCreateWorkspace);
  const isDisabled = isCreateButtonDisabled(items.length);

  const handlePress = useCallback(() => {
    showCreateWorkspaceModal({
      trackingSource: 'WorkspaceSettingsFromWorkspace',
    });
  }, [showCreateWorkspaceModal]);

  if (!shouldShow) {
    return null;
  }

  return (
    <Tooltip disabled={!isDisabled} title={limitReachedTooltip}>
      <span>
        <IconButton2
          data-testid={ADD_WORKSPACE_BUTTON_KEY}
          icon={<IconPlus />}
          isDisabled={isDisabled}
          label={TEXT.newWorkspace}
          onPress={handlePress}
          size="small"
          variant="tertiary-dimmed"
        />
      </span>
    </Tooltip>
  );
};

TEXT.DEFINE({
  /** Aria label for the create workspace button */
  newWorkspace: 'New Workspace',
});

const ADD_WORKSPACE_BUTTON_KEY = 'add-new-workspace';
